module.exports = require('./lib/noGetters');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-lazy-cache/noGetters.js
 ** module id = 273
 ** module chunks = 2
 **/